import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/lib/data";

const chapters = [
  {
    n: "01",
    title: "Get approved in minutes",
    text: "No credit checks. No credit cards. No hassle. If you're ready to drive, you're ready to go.",
  },
  {
    n: "02",
    title: "Pick up your car",
    text: "Choose a Tesla or a Hyundai from just $55 a day — coverage, maintenance and 200 miles per day included. Rentals stay in the Central Florida area: Orange, Osceola, Lake, Seminole and Sumter counties.",
  },
  {
    n: "03",
    title: "Drive & keep earning",
    text: "Run Uber, Lyft, Instacart, DoorDash or Grubhub. You focus on the road — we handle the rest.",
  },
];

export const Manifesto = () => (
  <section id="how" data-testid="manifesto-section" className="bg-white py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <p className="text-gold-dark text-xs font-bold uppercase tracking-[0.3em] mb-5">The ORL Way</p>
            <h2 className="font-heading font-bold text-navy text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.02] tracking-tight">
              Three steps to the driver's seat.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 relative rounded-[1.5rem] overflow-hidden border border-navy/10 shadow-2xl aspect-[4/3]">
              <img src={IMAGES.keys} alt="Handing over car keys" className="w-full h-full object-cover" />
              <div
                className="absolute inset-0"
                style={{ background: "radial-gradient(circle at 28% 22%, rgba(212,175,55,0.28), transparent 55%)" }}
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/30 rounded-[1.5rem]" />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div className="group py-9 md:py-11 border-t border-navy/10 first:border-t-0 grid grid-cols-[auto_1fr] gap-5 md:gap-10 items-start">
              <span className="font-heading font-extrabold text-5xl md:text-7xl leading-none text-navy/10 group-hover:text-gold transition-colors duration-500">
                {c.n}
              </span>
              <div className="pt-1 md:pt-3">
                <h3 className="font-heading font-bold text-navy text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                <p className="mt-3 text-muted-foreground text-base md:text-lg leading-relaxed max-w-xl">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
